export const colors = {
    consumer: {
        // shiftLight is $color-shift with sass lighten function 45% applied https://github.com/spothero/consumer-web/blob/dadca3dcd261a878d86ceae2ee61ffe32fd44e4a/src/sass/filters/_QuickFilters.scss#L54
        shiftLight: '#e6f3ff',
        // blackLight is rgba($color-black, 0.02) https://github.com/spothero/consumer-web/blob/dadca3dcd261a878d86ceae2ee61ffe32fd44e4a/src/sass/filters/_QuickFilters.scss#L94
        blackLight: 'rgba(33, 33, 33, 0.02)',
    },
};
